import { IInvoiceDetails, InvoiceDetailsModel } from "../../InvoiceDetails.model";
import IPaymentDetails from "../../PaymentDetails.interface";
import { PaymentTypeEnum } from "../../enums/PaymentTypeEnum";

export interface IReviewAndPayPaymentStepModel {
    paymentType: PaymentTypeEnum;
    paymentDetails: IPaymentDetails;
    invoiceDetails: IInvoiceDetails;
    termsAccepted: boolean;
    paymentCompleted: boolean;
}

export class ReviewAndPayPaymentStepModel implements IReviewAndPayPaymentStepModel {
    paymentType: PaymentTypeEnum;
    paymentDetails: IPaymentDetails;
    invoiceDetails: IInvoiceDetails;
    termsAccepted: boolean;
    paymentCompleted: boolean;

    constructor() {
        this.paymentType = PaymentTypeEnum.NONE;
        this.paymentDetails = new PaymentDetails();
        this.invoiceDetails = new InvoiceDetailsModel();
        this.termsAccepted = false;
        this.paymentCompleted = false;
    }
    
    static isValid(model: IReviewAndPayPaymentStepModel): boolean {
        if (!model.termsAccepted) {
            return false;
        }

        if (model.paymentType === PaymentTypeEnum.CREDIT_CARD) {
            return model.paymentCompleted;
        } else if (model.paymentType === PaymentTypeEnum.BANK) {
            return InvoiceDetailsModel.validateModel(model.invoiceDetails);
        } else {
            return false;
        }
    }
}

export class PaymentDetails implements IPaymentDetails {
    checkoutKey: string;
    checkoutExpiry: Date;
    stripeKey: string;
    cardAmount: number;
    totalAmount: number;
    totalFees: number;
    currency: string;

    constructor() {
        this.checkoutKey = "";
        this.checkoutExpiry = new Date();
        this.stripeKey = "";
        this.cardAmount = 0;
        this.totalAmount = 0;
        this.totalFees = 0;
        this.currency = "EUR";
    }
}